import React, {FunctionComponent} from "react";
import {useIntl} from "react-intl";
import Layout from "../components/layout/Layout";
import TabList from "../components/molecules/tab/TabList";
import PageTitle from "../components/molecules/header/PageTitle";
import {RouteProps} from "react-router-dom";
import {TabPaneItem} from "../interfaces/TabInterfaces";

interface AdminViewProp extends RouteProps {
  adminTabs: Array<TabPaneItem>
}
const AdminView: FunctionComponent<AdminViewProp> = ({
    adminTabs,
  }) => {
  const intl = useIntl();
  return (
    <Layout>
      <div className="epow-content-body d-flex flex-column admin-view">
        <div className="mb-3">
          <PageTitle pageTitle={intl.formatMessage({ id: "admin_title" })} />
        </div>
        <TabList items={adminTabs} />
      </div>
    </Layout>
  )
}

export default AdminView;
